/**
 *  Reassembles the split [+372][local part] phone input into the strict E.164 form SK's
 *  Mobile-ID API expects (+ followed by digits only). Android keyboards and tel autofill
 *  inject grouping spaces/dashes and sometimes paste the full country-coded number into the
 *  local-part field — SK rejects anything that isn't +digits, so every separator must go and
 *  an already-present country code must not be doubled.
 */
export function normalisePhone(raw: string): string {
    const compact = raw.replace(/[\s\-().]/g, '');
    if (!compact) return '';
    if (compact.startsWith('+')) return compact;
    if (compact.startsWith('00')) return `+${compact.slice(2)}`;
    // 372 + a 7-8 digit subscriber number can only be a country-coded value; genuine local
    // numbers max out at 8 digits so they never reach this length.
    if (compact.startsWith('372') && compact.length >= 10) return `+${compact}`;
    return `+372${compact}`;
}
